import axios from 'axios';
import { property } from 'lodash';

import getUrl from 'utils/getUrl';
import {
  jsonApiHeaders,
  jsonApiFieldList,
  addQueryParams,
} from './utils/apiUtils';
import { mapPostLogicFromApiModel } from './dataMapper/postLogicDataMapper';
import { generateApiError } from './utils/apiErrorMessages';
import { SURVEY_TYPE_COLLECTION_PATH } from './config/EntityCollectionPathMap';

const getPostSurveyLogic = surveyId => {
  const url = addQueryParams(
    getUrl.apiV2(`${SURVEY_TYPE_COLLECTION_PATH}/${surveyId}/item/rules`),
    jsonApiFieldList.postSurveyLogic,
  );

  return axios
    .get(url, { headers: jsonApiHeaders })
    .then(property('data'))
    .catch(generateApiError())
    .then(mapPostLogicFromApiModel);
};

export default getPostSurveyLogic;
